import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import ReactTooltip from 'react-tooltip'

import { mapLevels } from '../../utils/levels'

export default class LevelSelect extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedValue: props.level
    }

    this.handleSelectChangeBound = this.handleSelectChange.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.level !== this.props.level) {
      this.setState(() => {
        return {
          selectedValue: nextProps.level
        }
      })
    }
  }

  render () {
    const { levels, noMockCourses, intendedCourseHasNoLevels, course } =
      this.props

    const disabled = noMockCourses || intendedCourseHasNoLevels

    const selectComponent = (
      <Select
        searchable
        options={mapLevels(levels, 42)}
        value={this.state.selectedValue}
        onChange={this.handleSelectChangeBound}
        placeholder={''}
        disabled={disabled || !course}
        matchProp="label"
        style={{
          boxShadow: 'none',
          height: '44px'
        }}
      />
    )

    return (
      <div className="level-select">
        {disabled && <ReactTooltip id="levelSelectTooltip" />}
        {noMockCourses ? (
          <div
            data-for="levelSelectTooltip"
            data-tip={'No journeys are available.'}
          >
            {selectComponent}
          </div>
        ) : (
          <div
            data-for="levelSelectTooltip"
            data-tip={'No levels are available for this journey.'}
          >
            {selectComponent}
          </div>
        )}
      </div>
    )
  }

  handleSelectChange (value) {
    this.setState(() => {
      return {
        selectedValue: value
      }
    })
    this.props.onLevelChange(value)
  }
}

LevelSelect.propTypes = {
  levels: PropTypes.array.isRequired,
  level: PropTypes.object,
  disabled: PropTypes.bool,
  onLevelChange: PropTypes.func.isRequired,
  noMockCourses: PropTypes.bool.isRequired,
  intendedCourseHasNoLevels: PropTypes.bool.isRequired,
  course: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/mini/LevelSelect.js